<!-- //
dialog 数据源表单添加
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="500px">
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px" style="padding-right: 50px;">
        <el-form-item prop="queryName" label="名称">
          <el-input v-model="form.queryName" clearable maxlength="50"/>
        </el-form-item>
        <el-form-item prop="queryType" label="类型">
          <el-select
              v-model="form.queryType"
              placeholder="请选择"
              clearable
              style="width: 100%">
            <el-option
                v-for="item in this.$store.getters.dictType['QUERY_TYPE']"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="text-align: right">
            <el-button size="small" @click="hideModal">取 消</el-button>
            <el-button type="primary" size="small" @click="handleOk" :loading="loading">确 定</el-button>
          </div>
        </el-form-item>
      </el-form>
  </el-dialog>
</template>

<script>

import SqlQueryApi from '@/api/datasvc/sqlQuery.api.js';

export default {
  name: 'ViewSqlQuerySupportAdd',
  components: {},
  dictTypes: [
    {dictType: 'QUERY_TYPE', dataType: String},
  ],
  data() {
    return {
      loading: false,
      visible: false,
      title: '新建数据源',
      opts: {},
      form: {
        id: null,
        queryName: null,
        queryType: 'SQL',// API/SQL
      },
      rules: {
        queryName: [{required: true, message: "请输入数据源名称", trigger: 'blur'}],
        queryType: [{required: true, message: "请选择类型", trigger: 'change'}],
      },
    }
  },
  props: {
  },
  methods: {
    showModal({data, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      this.visible = true;
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      // console.log("绑定数据值前=========>", JSON.stringify(this.form));
      opts.data = this.$util.mergeObject(this.form, opts.data)
      this.form = opts.data
      this.title = opts.title
      // console.log("绑定数据值后=========>", JSON.stringify(this.form));
    },

    hideModal() {
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
      this.form.id = null;
      console.log("hideModal=========>", JSON.stringify(this.form));
      this.visible = false;
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return SqlQueryApi.saveInfo(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("添加成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
